import App from '@/app.vue';
import sharedComponents from '@/components/shared';
import '@/helpers/api';
import '@/helpers/directives';
import '@/helpers/filters';
import '@/helpers/mixins';
import '@/plugins/handlebars';
import '@/plugins/reactive-provide';
import '@/plugins/taqadhi-ui';
import '@/plugins/toaster';
import '@/plugins/vee-validate';
import '@/plugins/vue-google-maps';
import '@/plugins/vue-the-mask';
import vuetify from '@/plugins/vuetify';
import router from '@/routes';
import store from '@/store/index';
import 'babel-polyfill'; // babel polyfill for IE11 and Safari 9
import Vue from 'vue';
import { listenForSessionChange } from './helpers/utils';

import '@/assets/scss/main.scss';

Vue.config.productionTip = false;

listenForSessionChange();

for (const key in sharedComponents)
  if (Object.prototype.hasOwnProperty.call(sharedComponents, key))
    Vue.component(sharedComponents[key].name, sharedComponents[key]);

export default new Vue({
  router,
  store,
  render: h => h(App),
  vuetify,
})
  .$mount('#app');
